module.exports = __webpack_public_path__ + "static/media/chartSpeedBig.350152c7.png";